import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";


export const SetValidacionReplicacionSolicitud = (prestadorPuedeReplicar, usuarioPuedeReplicar) => ({
  type: "REP_SOLICITUD/SET_VALIDACION_USUARIO",
  prestadorPuedeReplicar,
  usuarioPuedeReplicar,
});

export const SetLoadingValidacionSolicitudEnCurso = (value) => ({
  type: "REP_SOLICITUD/SET_VALIDACION_EN_CURSO",
  value,
});

export const SetLoadingValidacionCentrosAtencion = (value) => ({
  type: "REP_SOLICITUD/SET_VALIDACION_CENTROS_ATENCION",
  value,
});

export const SetLoadingIdsHomologos = (value) => ({
  type: "REP_SOLICITUD/SET_IDS_HOMOLOGOS",
  value,
});

export const SetLoadingIdsHomologosAux = (value) => ({
  type: "REP_SOLICITUD/SET_IDS_HOMOLOGOS_AUX",
  value,
});

export const SetDetalleValidacionCentrosAtencion = (secuencia, valido, secuenciaHomologo) => ({
  type: "REP_SOLICITUD/SET_DETALLE_VALIDACION_CENTROS_ATENCION",
  secuencia,
  valido,
  secuenciaHomologo,
});

export const SetDetalleValidacionIdsHomologos = (idsHomologos) => ({
  type: "REP_SOLICITUD/SET_DETALLE_VALIDACION_IDS_HOMOLOGOS",
  idsHomologos,
});

export const MostrarValidacionesReplicar = (value) => ({
  type: "REP_SOLICITUD/MOSTRAR_VALIDACIONES_PARA_REPLICAR",
  value,
});

export const SetLoadingDetalleSolicitud = (value) => ({
  type: "REP_SOLICITUD/SET_LOADING_DETALLE_SOLICITUD",
  value,
});

export const DoneDetalleSolicitud = () => ({
  type: "REP_SOLICITUD/DONE_DETALLE_SOLICITUD",
});

export const MostrarSolicitudReplicada = (value) => ({
  type: "REP_SOLICITUD/MOSTRAT_SOLICITUD_REPLICADA",
  value,
});

export const GuardarIdSolicitudReplicacion = (value) => ({
  type: "REP_SOLICITUD/GUARDAR_ID_SOLICITUD_REPLICACION",
  value,
});


// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const PermiteReplicarSolicitud = () => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutUsuario: globalState.rutUsuario,
    RutPrestador: globalState.rutPrestador,
    Isapre: globalState.isapre,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/PermiteReplicarSolicitud/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("PermiteReplicarSolicitud", result);
    dispatch(SetValidacionReplicacionSolicitud(result.PrestadorPuedeReplicar, result.UsuarioPuedeReplicar));
  }), (error) => {
    trace.error("PermiteReplicarSolicitud", error);
    dispatch(ErrorSnacktOpen(
      "Error al validar replicacion de solicitud:",
      error,
    ));
  });
};

export const IniciarValidacionesReplicacionSolicitud = () => (dispatch) => {
  const globalState = store.getState().global;
  const prestaciones = store.getState().grillaSolicitud.prestacionesSolicitud;
  const isapreReplicar = globalState.isapre; // === "B" ? "T" : "B";
  const tipoAccion = prestaciones.filter((p) => p.COD_OPERACION.length > 0).map((p) => p.COD_OPERACION);
  let secuencias = prestaciones.map((p) => p.SECUENCIA);

  // Distinct
  // codsFonasa = codsFonasa.filter((v, i, a) => a.indexOf(v) === i);
  secuencias = secuencias.filter((v, i, a) => a.indexOf(v) === i);


  // Validar Centros de Atencion
  if (secuencias.length > 0) {
    for (let i = 0; i < secuencias.length; i += 1) {
      dispatch(SetDetalleValidacionCentrosAtencion(secuencias[i]));
    }
    for (let i = 0; i < secuencias.length; i += 1) {
      dispatch(validaCentroAtencion(
        isapreReplicar, secuencias[i],
        () => dispatch(ValidarPrestacionesSolicitudEnCurso(isapreReplicar)),
        () => dispatch(SetLoadingValidacionSolicitudEnCurso(false))
      ));
    }
  } else {
    dispatch(SetLoadingValidacionCentrosAtencion(true));
  }

  // Validar Ids Homologos
  const prestAValidar = prestaciones.filter((p) => p.IDPRESTACION > 0).map((p) => p.IDPRESTACION);
  if (prestAValidar.length > 0) {
    dispatch(ValidaIdsHomologos(prestAValidar, tipoAccion));
  } else {
    dispatch(SetLoadingIdsHomologos(true));
  }
};

export const ValidarPrestacionesSolicitudEnCurso = (isapreReplicar) => (dispatch) => {
  const globalState = store.getState().global;
  const grillaSolicitudState = store.getState().grillaSolicitud;
  const replicarSolicitudState = store.getState().replicarSolicitud;

  const secuenciasHomologas = replicarSolicitudState.detalleValidacionCentrosAtencion;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: isapreReplicar === 'B' ? 'T' : 'B',
    Prestaciones: [],
    token: globalState.token,
  };

  //console.log('params validar solicitudes activas:', params);

  for (let i = 0; i < grillaSolicitudState.prestacionesSolicitud.length; i += 1) {
    const secHomologa = secuenciasHomologas.filter((s) => s.secuencia === grillaSolicitudState.prestacionesSolicitud[i].SECUENCIA);
    const secHomologaValor = secHomologa && secHomologa.length > 0 ? secHomologa[0].secuenciaHomologo : null;
    params.Prestaciones.push({
      Grupo: grillaSolicitudState.prestacionesSolicitud[i].TIPO_PRESTACION,
      CodPrestacion: grillaSolicitudState.prestacionesSolicitud[i].COD_PRESTADOR,
      CofProf: grillaSolicitudState.prestacionesSolicitud[i].PROF_CCOD,
      TipoAtencion: grillaSolicitudState.prestacionesSolicitud[i].TIPO_ATENCION,
      CentroAtencion: secHomologaValor,
      Arancel: grillaSolicitudState.prestacionesSolicitud[i].RUTARANCEL,
    });
  }
  fetch(`${apiConfig.apiUri}/v1/solicitudes/ExisteDetalleSolicitudEnCurso/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("ValidarPrestacionesSolicitudEnCurso", result);
    if (result.filter((r) => r.ExisteEnCurso).length > 0) {
      dispatch(SetLoadingValidacionSolicitudEnCurso(false));
    } else {
      dispatch(SetLoadingValidacionSolicitudEnCurso(true));
    }
  }), (error) => {
    trace.error("ValidarPrestacionesSolicitudEnCurso", error);
  });
};

export const validaCentroAtencion = (isapreReplicar, secuencia, callbackSuccess, callbackError) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Secuencia: secuencia,
    Isapre: isapreReplicar,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/centroatencion/SecuenciaHomologacion/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("validaCentroAtencion", json);
      let secuenciaExiste = false;
      if (json && json.Existe && json.Existe === true) {
        secuenciaExiste = true;
      }
      if (secuenciaExiste) {
        dispatch(SetDetalleValidacionCentrosAtencion(secuencia, true, json.Secuencia));
      } else {
        dispatch(SetDetalleValidacionCentrosAtencion(secuencia, false));
      }

      const replicarSolicitudState = store.getState().replicarSolicitud;
      // Si se recorrieron todos las otras validaciones
      if (replicarSolicitudState.detalleValidacionCentrosAtencion
        .filter((c) => c.valido == null).length === 0) {
        const todosCentrosAtencionValidos = replicarSolicitudState.detalleValidacionCentrosAtencion
          .filter((c) => c.valido === false).length === 0;
        dispatch(SetLoadingValidacionCentrosAtencion(todosCentrosAtencionValidos));

        if (todosCentrosAtencionValidos) {
          callbackSuccess();
        } else {
          callbackError();
        }
      }
    })
    .catch((error) => {
      trace.error("validaCentroAtencion", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar centros de atencion:",
        error,
      ));
    });
};

export const ValidaIdsHomologos = (prestAValidar, tipoAccion) => (dispatch) => {
  const globalState = store.getState().global;
  const prestaciones = store.getState().grillaSolicitud.prestacionesSolicitud;
  const params = {
    Isapre: globalState.isapre,
    Prestaciones: prestAValidar,
    token: globalState.token,
  };
  fetch(`${apiConfig.apiUri}/v1/prestaciones/validarIdsHomologos/`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      //trace.information("validarIdsHomologos", json);
      if (json && json.length > 0 && json.length === prestAValidar.length &&
        json.filter((p) => p.IdPrestacionHomologa === 0).length === 0) {
        dispatch(SetDetalleValidacionIdsHomologos(json));
        dispatch(SetLoadingIdsHomologos(true));
        dispatch(SetLoadingIdsHomologosAux(true));
      } else {
        if (json.filter((p) => p.IdPrestacionHomologa === 0).length > 0 && tipoAccion.filter((p) => p === '2').length === prestAValidar.length && prestAValidar.length === prestaciones.length) {
          //trace.information("Todo ELIMINAR Y SIN HOMOLOGO");
          dispatch(SetLoadingIdsHomologos(false));
          dispatch(SetLoadingIdsHomologosAux(false));
        } else {
          dispatch(SetLoadingIdsHomologos(false));
          dispatch(SetLoadingIdsHomologosAux(true));
        }
      }
    })
    .catch((error) => {
      trace.error("validarIdsHomologos", error);
      dispatch(ErrorSnacktOpen(
        "Error al validar Ids homologos:",
        error,
      ));
    });
};

export const GuardarSolicitudParametrizada = () => (dispatch) => {
  const globalState = store.getState().global;
  const prestaciones = store.getState().grillaSolicitud.prestacionesSolicitud;
  const idSolicitud = store.getState().grillaSolicitud.idSolicitud;
  const idSolicitudHomologador = store.getState().grillaSolicitud.IdSolicitudHomologador || null;
  const replicarSolicitudState = store.getState().replicarSolicitud;

  const secuenciasHomologas = replicarSolicitudState.detalleValidacionCentrosAtencion;
  const idsPrestacionesHomol = replicarSolicitudState.idsPrestacionesHomologas;

  const prestacionesDetalle = [];
  prestaciones.forEach((prestacion) => {
    const secHomologa = secuenciasHomologas.filter((s) => s.secuencia === prestacion.SECUENCIA);
    const secHomologaValor = secHomologa && secHomologa.length > 0 ? secHomologa[0].secuenciaHomologo : null;

    const idPrestacionH = idsPrestacionesHomol.filter((p) => p.IdPrestacion === prestacion.IDPRESTACION);
    const idPrestacionHValor = idPrestacionH && idPrestacionH.length > 0 ? idPrestacionH[0].IdPrestacionHomologa : null;

    let FinVig = null;
    let FechaFinVigencia = null;
    let InicioVig = null;
    let newInicioVig = null;
    let InicioVigPrev = null;
    let newInicioVigPrev = null;
    let auxEliminar = 1;

    if (prestacion.INICIO_VIG) {
      InicioVig = new Date(prestacion.INICIO_VIG);
      newInicioVig = `${InicioVig.getDate()}/${InicioVig.getMonth() + 1}/${InicioVig.getFullYear()} 00:00:00`;
    }
    if (prestacion.INICIO_VIG_PREV) {
      InicioVigPrev = new Date(prestacion.INICIO_VIG_PREV);
      newInicioVigPrev = `${InicioVigPrev.getDate()}/${InicioVigPrev.getMonth() + 1}/${InicioVigPrev.getFullYear()} 00:00:00`;
    }
    if (prestacion.FECHA_FIN_VIG) {
      FinVig = new Date(prestacion.FECHA_FIN_VIG);
      FechaFinVigencia = `${FinVig.getDate()}/${FinVig.getMonth() + 1}/${FinVig.getFullYear()} 00:00:00`;
    }
    const CodPertenenciaFonasa = prestacion.PERTENENCIA_FONASA || 0;
    const codigoFonasa = prestacion.CODIGO_FONASA;
    const guarismo = prestacion.GUARISMO;
    const tipoAccionPrestacion = parseInt(prestacion.COD_OPERACION, 0) || 0;
    const arancel = prestacion.RUTARANCEL || 0;
    const valorAnterior = prestacion.VALOR || 0;
    const valorPosterior = prestacion.VALOR || 0;
    const grupoPrestacionPrestador = prestacion.TIPO_PRESTACION || 0;
    const prestacionDetalle = {
      // IdSolicitud: null,
      CentroAtencionSecuencia: secHomologaValor, // prestacion.SECUENCIA,
      Arancel: arancel,
      CodigoFonasa: codigoFonasa,
      Guarismo: guarismo,
      IdPrestacionIsapre: idPrestacionHValor,
      ItemImed: prestacion.ITEM_IMED,
      IdTipoAccionPrestacion: tipoAccionPrestacion,
      PertenenciaFonasa: CodPertenenciaFonasa,
      TipoAtencion: prestacion.TIPO_ATENCION,
      GlosaPrestacionPrestador: prestacion.GLOSA_CODPRESTADOR,
      GlosaGrupoPrestacionPrestador: prestacion.GLOSA_GRUPO_PRESTACION,

      CodigoPrestacionIsapre: null,
      CodigoPrestacionPrestador: prestacion.COD_PRESTADOR,
      CodigoProfesionalIsapre: null,
      CodigoProfesionalPrestador: prestacion.PROF_CCOD,
      FechaInicioVigenciaAnterior: null,
      FechaInicioVigenciaPosterior: null,
      FechaTerminoVigenciaAnterior: null,
      FechaTerminoVigenciaPosterior: null,
      GrupoPrestacionIsapre: null,
      GrupoPrestacionPrestador: grupoPrestacionPrestador,
      UnidadAnterior: null,
      UnidadPosterior: prestacion.UNIDAD,
      ValorAnterior: null,
      ValorPosterior: valorPosterior,
    };

    // Agregar
    if (tipoAccionPrestacion === 1) {
      prestacionDetalle.FechaInicioVigenciaPosterior = newInicioVig;
    }
    // Modificar
    if (tipoAccionPrestacion === 3) {
      prestacionDetalle.FechaInicioVigenciaAnterior = newInicioVigPrev;
      prestacionDetalle.FechaInicioVigenciaPosterior = newInicioVig;
      prestacionDetalle.FechaTerminoVigenciaAnterior = null;
      prestacionDetalle.FechaTerminoVigenciaPosterior = null;
      prestacionDetalle.UnidadAnterior = prestacion.UNIDAD_ANT;
      prestacionDetalle.ValorAnterior = prestacion.VALOR_ANT;
      prestacionDetalle.CodigoPrestacionIsapre = prestacion.COD_ISAPRE;
      prestacionDetalle.CodigoProfesionalIsapre = prestacion.PROF_CCOD;
      prestacionDetalle.GrupoPrestacionIsapre = grupoPrestacionPrestador;
    }
    // Eliminar
    if (tipoAccionPrestacion === 2) {
      if (idPrestacionHValor === null) {
        auxEliminar = 0;
      } else {
        prestacionDetalle.FechaInicioVigenciaAnterior = newInicioVigPrev;
        prestacionDetalle.FechaInicioVigenciaPosterior = null;
        prestacionDetalle.FechaTerminoVigenciaAnterior = null;
        prestacionDetalle.FechaTerminoVigenciaPosterior = FechaFinVigencia;
        prestacionDetalle.UnidadAnterior = prestacion.UNIDAD;
        prestacionDetalle.ValorAnterior = valorAnterior;
        prestacionDetalle.CodigoPrestacionIsapre = prestacion.COD_PRESTADOR;
        prestacionDetalle.CodigoProfesionalIsapre = prestacion.PROF_CCOD;
        prestacionDetalle.GrupoPrestacionIsapre = grupoPrestacionPrestador;
      }
    }

    if (tipoAccionPrestacion === 3 && idPrestacionHValor === null) {
      prestacionDetalle.IdTipoAccionPrestacion = 1;
      prestacionDetalle.IdPrestacionIsapre = 0;
      prestacionDetalle.CodigoPrestacionIsapre = prestacion.COD_ISAPRE;
      prestacionDetalle.CodigoProfesionalIsapre = prestacion.PROF_CCOD;
      prestacionDetalle.GrupoPrestacionIsapre = grupoPrestacionPrestador;
      prestacionDetalle.FechaInicioVigenciaAnterior = newInicioVigPrev;
      prestacionDetalle.FechaInicioVigenciaPosterior = newInicioVig;
      prestacionDetalle.FechaTerminoVigenciaAnterior = null;
      prestacionDetalle.FechaTerminoVigenciaPosterior = null;
      prestacionDetalle.UnidadAnterior = prestacion.UNIDAD_ANT;
      prestacionDetalle.ValorAnterior = null;
    }
    if (auxEliminar === 1) {
      prestacionesDetalle.push(prestacionDetalle);
    }
  });

  let numNuevas = 0;
  let IdEstadoProceso = 0;
  let IdEstadoSolicitudWF = 0;
  let listaUsuarios = "";
  const prestacionesHomologadas = store.getState().grillaSolicitud.prestacionesHomologadas;

  //console.log("prestacionesDetalle: ", prestacionesDetalle);
  //console.log("prestacionesHomologadas: ", prestacionesHomologadas)
  if (prestacionesDetalle && prestacionesDetalle.length > 0) {
    numNuevas = prestacionesDetalle.filter((p) => (p.IdTipoAccionPrestacion === 1));
    numNuevas = numNuevas.length;

    if (numNuevas > 0) {
      if ((numNuevas - prestacionesHomologadas.length) != 0) {
        IdEstadoProceso = 15;
        IdEstadoSolicitudWF = 36;
        listaUsuarios = globalState.listaUsuariosContraloria;
      } else {
        IdEstadoProceso = 14;
        IdEstadoSolicitudWF = 38;
        listaUsuarios = globalState.listaUsuariosConvenio;
      }
    } else {
      IdEstadoProceso = 14;
      IdEstadoSolicitudWF = 38;
      listaUsuarios = globalState.listaUsuariosConvenio;
    }
  } else {
    dispatch(ErrorSnacktOpen("Error: no se encontraron prestaciones en la solicitud"));
  }

  dispatch(SetLoadingDetalleSolicitud(prestacionesDetalle.length));
  dispatch(MostrarSolicitudReplicada(true));

  const params = {
    RutPrestador: globalState.rutPrestador,
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre === "B" ? "T" : "B",
    IdEstadoSolicitud: 8, // --8: SolicitudEnviada
    IdTipoModificacionSolicitud: 11, // --11: ActualizarArancel
    IdEstadoAreaProceso: IdEstadoProceso,
    IdEstadoSolicitudWF,
    token: globalState.token,
    ListaUsuarios: listaUsuarios,
    usuarioMail: globalState.datosUsuario.mail,
    usuarioNombre: globalState.datosUsuario.nombre,
    IdSolicitudPadre: idSolicitud,
    RutUsuario: globalState.rutUsuario,
    IdSolicitudHomologador: idSolicitudHomologador,
  };
  fetch(`${apiConfig.apiUri}/v1/solicitudes/pushSolicitudParametrizada/`, {
    method: "POST",
    headers: {
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  }).then((res) => res.json().then((result) => {
    //trace.information("GuardarSolicitudParametrizada", result);
    if (result && result.length > 0 && result[0].IdSolicitud > 0) {
      dispatch(GuardarIdSolicitudReplicacion(result[0].IdSolicitud));
      dispatch(GuardarDetalleSolicitud(result[0].IdSolicitud, prestacionesDetalle));
    } else {
      dispatch(ErrorSnacktOpen("Error al replicar la solicitud:", result));
    }
  }), (error) => {
    trace.error("GuardarSolicitudParametrizada", error);
    dispatch(ErrorSnacktOpen(
      "Error al guardar solicitud parametrizada:",
      error,
    ));
  });
};

export const GuardarDetalleSolicitud = (idSolicitud, prestacionesDetalle) => (dispatch) => {
  const globalState = store.getState().global;
  prestacionesDetalle.forEach((p) => {
    const params = { detalleSolicitud: p };

    params.detalleSolicitud.IdSolicitud = idSolicitud;
    params.token = globalState.token;

    fetch(`${apiConfig.apiUri}/v1/solicitudes/pushDetalleSolicitud/`, {
      method: "POST",
      headers: {
        // "Content-Type": "application/json",
        // Authorization: localStorage.getItem('id_token'),
      },
      credentials: "same-origin",
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (!response.ok) { throw response; }
        return response.json();
      })
      .then(async (json) => {
        //trace.information("GuardarDetalleSolicitud", json);
        // dispatch(cargarTiposPrestacion(json));
        dispatch(DoneDetalleSolicitud());
        const { prestacionesHomologadas } = store.getState().grillaSolicitud;
        let diferencia = prestacionesDetalle.length - prestacionesHomologadas.length;
        let final = 0;

        if (diferencia === 0) {
          final = 1;
        } else {
          final = 0;
        }
        //console.log("Homologadas: ", prestacionesHomologadas)

        if (prestacionesHomologadas.length > 0) {
          for (let i = 0; i < prestacionesHomologadas.length; i++) {
            prestacionesHomologadas[i]["idSolicitud"] = idSolicitud;
            prestacionesHomologadas[i]["username"] = null;
          }
          await fetch(`${apiConfig.apiUri}/v1/solicitudes/updatePrestacionesHomologadas`, {
            method: 'POST',
            body: JSON.stringify({
              idSolicitud: idSolicitud,
              prestacionesHomologadas: prestacionesHomologadas,
              token: globalState.token,
              final: final,
            }),
          }).then(res => res.json().then(data => {
            //('updatePrestacionesHomologadasReplica', data);
          })).catch(error => {
            trace.error('updatePrestacionesHomologadasReplica', error);
            dispatch(ErrorSnacktOpen(
              "Error al guardar Homologación de prestaciones en la replica:",
              error,
            ));
          })
        }
      })
      .catch((error) => {
        trace.error("GuardarDetalleSolicitud", error);
        dispatch(ErrorSnacktOpen(
          "Error al guardar el detalle de la solicitud:",
          error,
        ));
      });
  });
};
